var _this = this,
  _jsxFileName = "/builds/EgNbCExi/0/ramsey-solutions/ramsey-plus/survey-ui/src/components/Page/Page.js";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* eslint-disable no-extra-parens */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Formik } from "formik";
import * as Yup from "yup";
import Alert from "../Alert/Alert";
import BackButton from "../BackButton/BackButton";
import Form from "../Form/Form";
import QuestionByType from "../QuestionByType/QuestionByType";
import ProgressBar from "../ProgressBar/ProgressBar";
import SubmitButton from "../SubmitButton/SubmitButton";
import transformQuestionResponses from "../../transformQuestionResponses";
import { submitPage } from "../../network/surveyClient";
import validate from "../../util/validationSchema";
var Page = function Page(_ref) {
  var googleAnalyticsSurveyTrackingName = _ref.googleAnalyticsSurveyTrackingName,
    surveyPage = _ref.surveyPage,
    onSubmit = _ref.onSubmit,
    _ref$unauthenticated = _ref.unauthenticated,
    unauthenticated = _ref$unauthenticated === void 0 ? false : _ref$unauthenticated;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    alertMessage = _useState2[0],
    setAlertMessage = _useState2[1];
  var currentQuestion = surveyPage.questions[0];
  var DEFAULT_KEY = "SURVEY";
  var currentKey = currentQuestion ? currentQuestion.alias : DEFAULT_KEY;

  // ! Required for MarTech tracking
  var ANALYTICS_TRACKING_FORM_NAME = "".concat(googleAnalyticsSurveyTrackingName, "_").concat(surveyPage._embedded.survey.id, "-").concat(surveyPage.progress.overall.current_page);
  var ERROR_MESSAGE = "We're sorry! We ran into a problem. Please try again.";

  /**
   * Populates answer values for questions already answered
   * @param  {Object} question Question
   * @returns {Object|string} Current answer(s) or answer id
   */
  var extractAnswers = function extractAnswers(question) {
    if (question.answer) {
      return question.answer;
    }
    if (question.answers && question.answers.length > 0) {
      switch (question.type) {
        case "CHECKBOX":
          return question.answers.map(function (answer) {
            return answer.id;
          });
        default:
          return question.answers[0].id;
      }
    }
    return "";
  };

  /**
   * Passed into Formik's `initialValues` to set the answers for previously submitted
   * questions.
   */
  var values = surveyPage.questions.reduce(function (valueAccumulator, question) {
    valueAccumulator[question.alias] = extractAnswers(question);
    return valueAccumulator;
  }, {});

  /**
   * @param  {any} userResponse Answers the user has selected
   * @param  {FormikBag} setSubmitting Formik function
   * @returns {void}
   */
  var handleSurveyPageSubmission = function handleSurveyPageSubmission(userResponse, _ref2) {
    var setSubmitting = _ref2.setSubmitting;
    var submissionEndpoint = surveyPage._embedded.next.href;
    var transformedPayload = transformQuestionResponses(surveyPage.questions, userResponse);
    setAlertMessage("");
    submitPage(submissionEndpoint, {
      // eslint-disable-next-line camelcase
      user_response: transformedPayload
    }, unauthenticated).then(function (response) {
      setSubmitting(false);
      onSubmit(response);
    })["catch"](function () {
      setAlertMessage(ERROR_MESSAGE);
      setSubmitting(false);
    });
  };

  /**
   * @param {string} fieldName The 'name' attribute on the HTML Input element
   * @returns {HTMLElement | undefined} HTML Input element
   */
  var getInputField = function getInputField(fieldName) {
    var inputElement = document.querySelector("[name=".concat(fieldName, "]"));
    return inputElement;
  };

  /**
   * The validation schema is run
   *  when the component mounts,
   *  when any field within the form changes,
   *  and before form submission.
   * @returns {Object} Yup validation object
   */
  var validationSchema = function validationSchema() {
    var _Yup$object;
    var validators = surveyPage.questions.reduce(function (validation, question) {
      var inputField = getInputField(question.alias);
      if (inputField) {
        validation.push(validate(inputField));
      }
      return validation;
    }, []);
    return (_Yup$object = Yup.object()).shape.apply(_Yup$object, _toConsumableArray(validators));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "survey-Page",
    "data-testid": "Page",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 126,
      columnNumber: 5
    }
  }, surveyPage._embedded.previous && surveyPage._embedded.previous.href ? /*#__PURE__*/React.createElement(BackButton, {
    surveyPage: surveyPage,
    analyticsTrackingName: "".concat(ANALYTICS_TRACKING_FORM_NAME, "-previous"),
    onSubmissionSuccess: onSubmit,
    unauthenticated: unauthenticated,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 128,
      columnNumber: 9
    }
  }) : null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: values,
    onSubmit: handleSurveyPageSubmission,
    validationSchema: validationSchema,
    key: currentKey,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 135,
      columnNumber: 7
    }
  }, function (_ref3) {
    var isValid = _ref3.isValid,
      isSubmitting = _ref3.isSubmitting;
    return /*#__PURE__*/React.createElement(Form, {
      id: "surveyForm",
      "data-analytics-form": ANALYTICS_TRACKING_FORM_NAME,
      noValidate: true,
      validateFormikOnMount: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 142,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "survey-Page-progress",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 148,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(ProgressBar, {
      progress: surveyPage.progress.overall,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 149,
        columnNumber: 15
      }
    })), /*#__PURE__*/React.createElement(QuestionByType, {
      question: currentQuestion,
      submission: /*#__PURE__*/React.createElement(React.Fragment, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 155,
          columnNumber: 17
        }
      }, /*#__PURE__*/React.createElement(Alert, {
        message: alertMessage,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 157,
          columnNumber: 19
        }
      }), /*#__PURE__*/React.createElement(SubmitButton, {
        currentPage: surveyPage.progress.overall.current_page,
        totalPages: surveyPage.progress.overall.total_pages,
        disabled: !isValid || isSubmitting,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 159,
          columnNumber: 19
        }
      })),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 152,
        columnNumber: 13
      }
    }));
  }));
};
Page.propTypes = {
  googleAnalyticsSurveyTrackingName: PropTypes.string.isRequired,
  surveyPage: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired
};
export default Page;